export default "__VITE_ASSET__BYAmBVij__"